<template>
  <div class="tw:inline-block tw:text-gray-700 tw:hover:text-blue-800 tw:hover:bg-gray-200 tw:p-2 tw:rounded-lg">
    <a
      :href="supportCenterUrl({ language })"
      data-tooltip
      target="_blank"
      class="tw:flex tw:items-center tw:relative tw:text-gray-800 tw:hover:no-underline"
      @click="trackClickEvent"
      @keydown.enter="trackClickEvent"
      data-testid="header-loggedin-support-center-link"
    >
      <QuestionMark class="tw:fill-gray-800 tw:size-6" :class="isMobile ? 'tw:mr-1' : 'tw:mr-2'" />
      <span v-if="!isMobile" class="tw:hidden tw:landing:flex tw:text-sm tw:text-gray-800 tw:mr-1">{{
        $t('navigation.supportCenter')
      }}</span>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import QuestionMark from '@/components/icons/QuestionMark.svg?component'
import { getSupportCenterUrl } from '@/utils/Utility.ts'
import appAnalytics from '@/utils/tracking'
import { selectedAccommodationId } from '@/layouts/queries'
import { useCampaign } from '@/components/rateConnect/queries'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useSessionValues } from '@/composables/useSessionValues'

defineProps({
  isMobile: Boolean,
})
const { language, userId } = useSessionValues()
const { campaignsData } = useCampaign(selectedAccommodationId)
const { studioPlusCampaign } = useStudioPlusCampaign(selectedAccommodationId)
const isPaidClient = computed(
  () =>
    Boolean(studioPlusCampaign.value) ||
    (Array.isArray(campaignsData.value) ? campaignsData.value.length > 0 : Boolean(campaignsData.value))
)

const supportCenterUrl = locale =>
  getSupportCenterUrl(locale.language, userId.value, selectedAccommodationId.value, isPaidClient.value)
const trackClickEvent = () => {
  appAnalytics.track(appAnalytics.events.BUTTON_CLICKED, {
    button: 'support_center',
    property_id: selectedAccommodationId.value,
  })
}
</script>
